// extracted by mini-css-extract-plugin
module.exports = {"titleBox":"Welcome_titleBox__gPu3T","title":"Welcome_title__Cz_nm"};